import React from "react";
import { Grid2 } from "@mui/material";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../utils/auth";
import { useUserInfo } from "../../utils/user";
import Loading from "../Layout/Loading";

const Coaching = () => {
  const { user } = useAuth();
  const {
    stripeAccountId,
    paymentsProEnabled,
    stripeDetailsSubmitted,
    loading,
  } = useUserInfo();
  if (loading) {
    return <Loading style={{ m: 4 }} />;
  }

  if (!user) {
    return (
      <Grid2 sx={{ mt: 4 }}>
        <Navigate to="/coaching/landing" />
      </Grid2>
    );
  }

  // Payments Pro users with Stripe account must finish onboarding
  // Don't redirect to create-account if they have paymentsPro but no stripeAccountId yet
  if (paymentsProEnabled && stripeAccountId && !stripeDetailsSubmitted) {
    return (
      <Grid2 sx={{ mt: 4 }}>
        <Navigate to="/coaching/create-account-link" />
      </Grid2>
    );
  }

  return (
    <Grid2 sx={{ mt: 4 }}>
      <Navigate to="/clients" />
    </Grid2>
  );
};

export default Coaching;
